import React, {useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {addClass, checkNullStr, createTimeout, getJsonValue, getElement, isBoolTrue, isJsonValueTrue} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getUserSessionField, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Flexbox, MsgBox} from "../../../../common/fusion-ui";
import {CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";

const UserProfile_Edit_FormPanel = React.memo(({
                                                   recordId,
                                                   asPanel = true,
                                                   showCancel = false,
                                                   onCancel,
                                                   onSuccess,
                                                   onFailure,
                                               }) => {
    const TAG = "UserProfile_Edit_FormPanel";

    const moduleName = Modules.UserProfile;
    const mf = ModuleFieldsData[moduleName];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        username: 'username',
        loginPin: 'loginPin',
        password: 'password',
        confirmPassword: 'confirmPassword',

        passwordMsg: 'passwordMsg',
        confirmPasswordMsg: 'confirmPasswordMsg',
        loginPinMsg: 'loginPinMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});

    return (<>
        {isBoolTrue(asPanel) ? createForm() : createFormPage()}
    </>)

    function createFormPage() {
        return <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            {createForm()}
        </FormPageRoot>
    }

    function createForm() {
        return <div>
            <div className={'px-2'}>
                {/*inputs*/}
                <div>
                    {/*username*/}
                    <ThemedInput
                        className={`py-2`}
                        type={'text'}
                        label={'Username'}
                        placeholder={'Username'}
                        value={getUserSessionField(Fields.username)}
                        readOnly={true}
                    />
                    {/*current-pw*/}
                    <ThemedInput
                        className={`py-2`}
                        type={'password'}
                        label={'Current Password'}
                        placeholder={'Current Password'}
                        value={getUserSessionField('passwordOld')}
                        readOnly={true}
                        showPasswordToggle={false}
                    />
                    {/*loginPin*/}
                    {/*<ThemedInput*/}
                    {/*    className={`py-2`}*/}
                    {/*    type={'password'}*/}
                    {/*    id={Fields.loginPin}*/}
                    {/*    label={'Login PIN'}*/}
                    {/*    placeholder={'Login PIN'}*/}
                    {/*    value={getUserSessionField(Fields.loginPin)}*/}
                    {/*    // value={getField(Fields.loginPin)}*/}
                    {/*    // required={true}*/}
                    {/*    readOnly={true}*/}
                    {/*    msg={getField(Fields.loginPinMsg)}*/}
                    {/*    // onChange={(e) => {*/}
                    {/*    //     const value = e.target.value;*/}
                    {/*    //     updateField(Fields.loginPin, value);*/}
                    {/*    //     if (checkNullStr(value)) {*/}
                    {/*    //         panelLog('');*/}
                    {/*    //         highlightIdField(Fields.loginPin, false, Fields.loginPinMsg, '');*/}
                    {/*    //     }*/}
                    {/*    // }}*/}
                    {/*/>*/}

                    {/*password*/}
                    <ThemedInput
                        className={`py-2`}
                        type={'password'}
                        id={Fields.password}
                        label={'Password'}
                        placeholder={'Create password'}
                        value={getField(Fields.password)}
                        required={true}
                        msg={getField(Fields.passwordMsg)}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateField(Fields.password, value);
                            if (checkNullStr(value)) {
                                panelLog('');
                                highlightIdField(Fields.password, false, Fields.passwordMsg, '');
                            }
                        }}
                    />

                    {/*confirmPassword*/}
                    <ThemedInput
                        className={`py-2`}
                        type={'password'}
                        id={Fields.confirmPassword}
                        label={'Confirm password'}
                        placeholder={'Re-type your password'}
                        value={getField(Fields.confirmPassword)}
                        required={true}
                        msg={getField(Fields.confirmPasswordMsg)}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateField(Fields.confirmPassword, value);
                            if (checkNullStr(value)) {
                                panelLog('');
                                highlightIdField(Fields.confirmPassword, false, Fields.confirmPasswordMsg, '');
                            }
                        }}
                    />
                </div>

                {/*footer*/}
                <div className={'mt-3'}>
                    {/*msg-box*/}
                    {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                    {/*controls*/}
                    <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                        {/*cancel*/}
                        {isBoolTrue(showCancel) && <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={'Cancel'}
                            variant={theme.text10}
                            hoverBgColor={theme.text20}
                            color={theme.text}
                            hoverColor={theme.text}
                            mx={2}
                            onClick={onCancel}
                        />}

                        <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Updating...' : 'Update'}
                            variant={theme.primaryBlue}
                            mx={2}
                            hoverBgColor={theme.primaryBlueDark}
                            loadingWidth={'auto'}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                        />
                    </Flexbox>
                </div>
            </div>
        </div>
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        try {
            const formData = getFormRecordToUpload();
            log(fun, 'formData:', formData);
            if (!isOnline) {
                toast(internetCheckingMsg, CssVariant.warning);
                return false;
            }

            let allFieldsChecked = checkRequiredFields(formData);
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    formData: formData,
                };
                sendRequest({
                    reqUrl: ReqUrls.resetUserPassword,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (!isBoolTrue(asPanel)) redirectPage();
                            if (onSuccess) onSuccess(message);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                            if (onFailure) onFailure(message);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                        if (onFailure) onFailure(error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
            if (onFailure) onFailure(error);
        }
    }

    function getFormRecordToUpload() {
        return {
            [Fields.username]: getUserSessionField('username'),
            [Fields.loginPin]: getUserSessionField('loginPin'),
            [Fields.password]: getField(Fields.password),
            [Fields.confirmPassword]: getField(Fields.confirmPassword),
        };
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                window.location.href = ModuleRouteUrls[moduleName];
            }, 2500);
        }, 500);
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields(formData = {}) {
        const fun = 'checkRequiredFields:';
        try {
            const requiredFields = [
                Fields.password,
                Fields.confirmPassword,
            ];
            let verified = false;

            const emptyField = requiredFields.find((field) => !checkNullStr(formData[field]));
            if (emptyField) {
                updateField(Fields[emptyField + 'Msg'], 'Required field');
                focusIdField(emptyField);
                verified = false;
            } else {
                verified = true;
            }
            if (verified) {
                //validate each field
                const password = formData[Fields.password];
                const confirmPassword = formData[Fields.confirmPassword];
                if ((password != confirmPassword)) {
                    // highlightIdField(Fields.password, true, Fields.passwordMsg, "Password does not match");
                    highlightIdField(Fields.confirmPassword, true, Fields.confirmPasswordMsg, "Password does not match!");
                    focusIdField(Fields.confirmPassword);
                    toast("Password does not match!", CssVariant.danger);
                    verified = false;
                    log(fun, `passwords do not match, password:`, password, 'confirmPassword:', confirmPassword);
                } else {
                    verified = true;
                }
            }
            return verified;
        } catch (e) {
            logErr(e);
            panelLogErr("Please fill the required fields");
            return false;
        }
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getTabTitle() {
        return `Edit Profile`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default UserProfile_Edit_FormPanel;
